import script from "./object_simplePageText.vue?vue&type=script&setup=true&lang=js"
export * from "./object_simplePageText.vue?vue&type=script&setup=true&lang=js"

import "./object_simplePageText.vue?vue&type=style&index=0&id=3c8af840&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8af840"]])

export default __exports__